module.exports = __webpack_public_path__ + "mail-icon.png?88ba031f6a2fe1f074b307ff4a3e4a87";